// extracted by mini-css-extract-plugin
module.exports = {"box":"box--2ADdy","carousel":"carousel--3sGEU","tit":"tit--20IRe"};